import { OrganizationEntity } from '../types';

export const ORG_STATE_UPDATED = 'ORG_STATE_UPDATED';
export const CREATE_ORG_CHECKLIST_ITEM_TEMPLATE = 'CREATE_ORG_CHECKLIST_ITEM_TEMPLATE';
export const UPDATE_ORG_CHECKLIST_ITEM_TEMPLATE = 'UPDATE_ORG_CHECKLIST_ITEM_TEMPLATE';
export const DELETE_ORG_CHECKLIST_ITEM_TEMPLATE = 'DELETE_ORG_CHECKLIST_ITEM_TEMPLATE';
export const CREATE_ORG_TAG = 'CREATE_ORG_TAG';
export const UPDATE_ORG_TAG = 'UPDATE_ORG_TAG';
export const DELETE_ORG_TAG = 'DELETE_ORG_TAG';

export interface BaseUpdateOrgRequest {
    orgId: string;
}

export interface InviteTeamRequest extends BaseUpdateOrgRequest {
    emails: string[];
}

export interface OrgStateUpdatedAction {
    type: typeof ORG_STATE_UPDATED;
    payload: OrganizationEntity;
}

export enum OrgUpdatable {
    CreateOrgChecklistItemTemplate = CREATE_ORG_CHECKLIST_ITEM_TEMPLATE,
    UpdateOrgChecklistItemTemplate = UPDATE_ORG_CHECKLIST_ITEM_TEMPLATE,
    DeleteOrgChecklistItemTemplate = DELETE_ORG_CHECKLIST_ITEM_TEMPLATE,
    CreateOrgTag = CREATE_ORG_TAG,
    UpdateOrgTag = UPDATE_ORG_TAG,
    DeleteOrgTag = DELETE_ORG_TAG,
}

// Action Creators

export const orgStateUpdated: (payload: OrganizationEntity) => OrgStateUpdatedAction = (payload) => {
    return {
        type: ORG_STATE_UPDATED,
        payload,
    };
};
